var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "78pt",
    height: "68pt",
    viewBox: "0 0 78 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.296875 -4.484375 L 4.375 -6.65625 C 4.34375 -6.734375 4.3125 -6.78125 4.3125 -6.796875 C 4.3125 -6.859375 4.5 -7.0625 4.96875 -7.109375 C 5.078125 -7.125 5.1875 -7.125 5.1875 -7.3125 C 5.1875 -7.453125 5.046875 -7.453125 5.015625 -7.453125 C 4.5625 -7.453125 4.09375 -7.421875 3.640625 -7.421875 C 3.375 -7.421875 2.6875 -7.453125 2.421875 -7.453125 C 2.359375 -7.453125 2.21875 -7.453125 2.21875 -7.234375 C 2.21875 -7.109375 2.328125 -7.109375 2.46875 -7.109375 C 3.125 -7.109375 3.203125 -7 3.296875 -6.765625 L 4.578125 -3.71875 L 2.28125 -1.25 L 2.140625 -1.125 C 1.609375 -0.546875 1.09375 -0.375 0.53125 -0.34375 C 0.390625 -0.328125 0.296875 -0.328125 0.296875 -0.125 C 0.296875 -0.109375 0.296875 0 0.4375 0 C 0.765625 0 1.125 -0.03125 1.46875 -0.03125 C 1.859375 -0.03125 2.296875 0 2.6875 0 C 2.75 0 2.875 0 2.875 -0.21875 C 2.875 -0.328125 2.765625 -0.34375 2.75 -0.34375 C 2.65625 -0.34375 2.3125 -0.375 2.3125 -0.671875 C 2.3125 -0.84375 2.46875 -1.03125 2.609375 -1.171875 L 3.71875 -2.34375 L 4.703125 -3.40625 L 5.796875 -0.8125 C 5.84375 -0.6875 5.859375 -0.671875 5.859375 -0.65625 C 5.859375 -0.5625 5.65625 -0.375 5.21875 -0.34375 C 5.109375 -0.328125 5 -0.3125 5 -0.125 C 5 0 5.125 0 5.171875 0 C 5.46875 0 6.234375 -0.03125 6.546875 -0.03125 C 6.8125 -0.03125 7.484375 0 7.75 0 C 7.828125 0 7.96875 0 7.96875 -0.203125 C 7.96875 -0.34375 7.859375 -0.34375 7.765625 -0.34375 C 7.03125 -0.34375 7.015625 -0.375 6.828125 -0.8125 C 6.40625 -1.828125 5.671875 -3.53125 5.421875 -4.1875 C 6.15625 -4.953125 7.3125 -6.25 7.65625 -6.546875 C 7.96875 -6.8125 8.390625 -7.078125 9.046875 -7.109375 C 9.1875 -7.125 9.28125 -7.125 9.28125 -7.328125 C 9.28125 -7.34375 9.28125 -7.453125 9.140625 -7.453125 C 8.8125 -7.453125 8.453125 -7.421875 8.109375 -7.421875 C 7.703125 -7.421875 7.296875 -7.453125 6.90625 -7.453125 C 6.84375 -7.453125 6.703125 -7.453125 6.703125 -7.234375 C 6.703125 -7.15625 6.75 -7.125 6.828125 -7.109375 C 6.921875 -7.09375 7.265625 -7.078125 7.265625 -6.765625 C 7.265625 -6.625 7.140625 -6.484375 7.0625 -6.375 Z M 5.296875 -4.484375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.921875 -6.296875 C 7.03125 -6.75 7.234375 -7.078125 8.109375 -7.109375 C 8.15625 -7.109375 8.28125 -7.125 8.28125 -7.328125 C 8.28125 -7.34375 8.28125 -7.453125 8.140625 -7.453125 C 7.78125 -7.453125 7.40625 -7.421875 7.03125 -7.421875 C 6.65625 -7.421875 6.265625 -7.453125 5.90625 -7.453125 C 5.828125 -7.453125 5.703125 -7.453125 5.703125 -7.234375 C 5.703125 -7.109375 5.8125 -7.109375 5.90625 -7.109375 C 6.515625 -7.09375 6.640625 -6.875 6.640625 -6.625 C 6.640625 -6.59375 6.625 -6.4375 6.609375 -6.40625 L 5.625 -2.515625 C 5.25 -1.046875 4 -0.09375 2.90625 -0.09375 C 2.171875 -0.09375 1.578125 -0.578125 1.578125 -1.515625 C 1.578125 -1.53125 1.578125 -1.890625 1.703125 -2.359375 L 2.765625 -6.609375 C 2.859375 -7 2.875 -7.109375 3.671875 -7.109375 C 3.953125 -7.109375 4.046875 -7.109375 4.046875 -7.328125 C 4.046875 -7.453125 3.921875 -7.453125 3.890625 -7.453125 C 3.59375 -7.453125 2.796875 -7.421875 2.5 -7.421875 C 2.1875 -7.421875 1.40625 -7.453125 1.09375 -7.453125 C 1 -7.453125 0.890625 -7.453125 0.890625 -7.234375 C 0.890625 -7.109375 0.984375 -7.109375 1.1875 -7.109375 C 1.203125 -7.109375 1.421875 -7.109375 1.609375 -7.09375 C 1.796875 -7.0625 1.890625 -7.0625 1.890625 -6.921875 C 1.890625 -6.84375 1.78125 -6.390625 1.71875 -6.140625 L 1.46875 -5.1875 C 1.375 -4.75 0.84375 -2.6875 0.8125 -2.484375 C 0.734375 -2.1875 0.734375 -2.015625 0.734375 -1.859375 C 0.734375 -0.53125 1.71875 0.234375 2.875 0.234375 C 4.25 0.234375 5.59375 -1 5.953125 -2.4375 Z M 6.921875 -6.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.84375 -6.203125 C 7.390625 -7.0625 7.84375 -7.09375 8.25 -7.109375 C 8.375 -7.125 8.390625 -7.3125 8.390625 -7.3125 C 8.390625 -7.40625 8.328125 -7.453125 8.25 -7.453125 C 7.96875 -7.453125 7.640625 -7.421875 7.34375 -7.421875 C 6.984375 -7.421875 6.625 -7.453125 6.265625 -7.453125 C 6.203125 -7.453125 6.0625 -7.453125 6.0625 -7.234375 C 6.0625 -7.125 6.15625 -7.109375 6.234375 -7.109375 C 6.53125 -7.09375 6.734375 -6.984375 6.734375 -6.75 C 6.734375 -6.59375 6.578125 -6.34375 6.578125 -6.34375 L 3.234375 -1.015625 L 2.484375 -6.78125 C 2.484375 -6.96875 2.734375 -7.109375 3.234375 -7.109375 C 3.390625 -7.109375 3.515625 -7.109375 3.515625 -7.328125 C 3.515625 -7.421875 3.421875 -7.453125 3.359375 -7.453125 C 2.921875 -7.453125 2.453125 -7.421875 2 -7.421875 C 1.8125 -7.421875 1.609375 -7.421875 1.40625 -7.421875 C 1.203125 -7.421875 1 -7.453125 0.8125 -7.453125 C 0.734375 -7.453125 0.609375 -7.453125 0.609375 -7.234375 C 0.609375 -7.109375 0.703125 -7.109375 0.890625 -7.109375 C 1.5 -7.109375 1.5 -7.015625 1.53125 -6.734375 L 2.40625 -0.015625 C 2.4375 0.203125 2.46875 0.234375 2.625 0.234375 C 2.796875 0.234375 2.828125 0.1875 2.921875 0.046875 Z M 6.84375 -6.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.859375 1.859375 C 1.8125 2 1.796875 2.015625 1.796875 2.078125 C 1.796875 2.3125 2 2.375 2.109375 2.375 C 2.171875 2.375 2.40625 2.34375 2.515625 2.09375 C 2.546875 2 2.609375 1.640625 2.90625 0.09375 C 3 0.109375 3.078125 0.125 3.265625 0.125 C 5.078125 0.125 6.75 -1.59375 6.75 -3.3125 C 6.75 -4.171875 6.328125 -4.828125 5.5 -4.828125 C 3.921875 -4.828125 3.265625 -2.703125 2.625 -0.578125 C 1.4375 -0.796875 0.828125 -1.40625 0.828125 -2.1875 C 0.828125 -2.5 1.078125 -3.703125 1.734375 -4.453125 C 1.828125 -4.546875 1.828125 -4.5625 1.828125 -4.59375 C 1.828125 -4.640625 1.796875 -4.703125 1.6875 -4.703125 C 1.390625 -4.703125 0.546875 -3.125 0.546875 -2.078125 C 0.546875 -1.046875 1.265625 -0.25 2.4375 0.015625 Z M 3.359375 -0.515625 C 3.265625 -0.515625 3.25 -0.515625 3.15625 -0.53125 C 3.03125 -0.53125 3.015625 -0.53125 3.015625 -0.5625 C 3.015625 -0.59375 3.203125 -1.578125 3.234375 -1.75 C 3.578125 -3.140625 4.421875 -4.1875 5.40625 -4.1875 C 6.15625 -4.1875 6.453125 -3.59375 6.453125 -3.078125 C 6.453125 -1.84375 5.03125 -0.515625 3.359375 -0.515625 Z M 3.359375 -0.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 3.125 -7.453125 C 3.125 -7.453125 3.125 -7.5625 2.984375 -7.5625 C 2.734375 -7.5625 1.9375 -7.484375 1.65625 -7.453125 C 1.578125 -7.453125 1.453125 -7.4375 1.453125 -7.234375 C 1.453125 -7.109375 1.546875 -7.109375 1.71875 -7.109375 C 2.234375 -7.109375 2.25 -7.03125 2.25 -6.921875 L 2.21875 -6.703125 L 0.640625 -0.421875 C 0.59375 -0.265625 0.59375 -0.25 0.59375 -0.1875 C 0.59375 0.0625 0.8125 0.125 0.921875 0.125 C 1.09375 0.125 1.265625 -0.015625 1.3125 -0.15625 L 1.53125 -1 L 1.765625 -1.96875 C 1.828125 -2.21875 1.890625 -2.453125 1.953125 -2.703125 C 1.96875 -2.765625 2.0625 -3.125 2.078125 -3.203125 C 2.109375 -3.296875 2.4375 -3.90625 2.8125 -4.203125 C 3.046875 -4.375 3.390625 -4.578125 3.859375 -4.578125 C 4.328125 -4.578125 4.453125 -4.203125 4.453125 -3.8125 C 4.453125 -3.234375 4.03125 -2.046875 3.78125 -1.375 C 3.6875 -1.125 3.625 -1 3.625 -0.78125 C 3.625 -0.265625 4.015625 0.125 4.53125 0.125 C 5.546875 0.125 5.953125 -1.46875 5.953125 -1.5625 C 5.953125 -1.671875 5.859375 -1.671875 5.828125 -1.671875 C 5.71875 -1.671875 5.71875 -1.640625 5.65625 -1.46875 C 5.5 -0.890625 5.140625 -0.125 4.546875 -0.125 C 4.359375 -0.125 4.28125 -0.234375 4.28125 -0.484375 C 4.28125 -0.75 4.390625 -1.015625 4.484375 -1.25 C 4.65625 -1.71875 5.140625 -3.015625 5.140625 -3.65625 C 5.140625 -4.359375 4.71875 -4.828125 3.890625 -4.828125 C 3.203125 -4.828125 2.6875 -4.484375 2.28125 -3.984375 Z M 3.125 -7.453125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.25 -7.28125 C 5.265625 -7.328125 5.296875 -7.390625 5.296875 -7.453125 C 5.296875 -7.5625 5.21875 -7.5625 5.15625 -7.5625 C 5.046875 -7.5625 5.03125 -7.546875 5 -7.34375 L 3.1875 -0.140625 C 2.359375 -0.234375 1.9375 -0.640625 1.9375 -1.359375 C 1.9375 -1.578125 1.9375 -1.859375 2.53125 -3.390625 C 2.578125 -3.515625 2.65625 -3.703125 2.65625 -3.921875 C 2.65625 -4.421875 2.296875 -4.828125 1.75 -4.828125 C 0.71875 -4.828125 0.3125 -3.234375 0.3125 -3.140625 C 0.3125 -3.03125 0.421875 -3.03125 0.453125 -3.03125 C 0.5625 -3.03125 0.5625 -3.046875 0.625 -3.234375 C 0.921875 -4.265625 1.359375 -4.578125 1.71875 -4.578125 C 1.8125 -4.578125 2 -4.578125 2 -4.234375 C 2 -3.953125 1.890625 -3.671875 1.75 -3.296875 C 1.21875 -1.921875 1.21875 -1.640625 1.21875 -1.453125 C 1.21875 -0.421875 2.078125 0.03125 3.125 0.09375 C 3.03125 0.484375 3.03125 0.515625 2.875 1.09375 C 2.84375 1.203125 2.625 2.09375 2.625 2.125 C 2.625 2.140625 2.625 2.234375 2.765625 2.234375 C 2.78125 2.234375 2.828125 2.234375 2.859375 2.1875 C 2.890625 2.171875 2.953125 1.890625 2.984375 1.75 L 3.40625 0.125 C 3.8125 0.125 4.765625 0.125 5.796875 -1.046875 C 6.234375 -1.546875 6.46875 -2.03125 6.59375 -2.359375 C 6.6875 -2.625 6.921875 -3.578125 6.921875 -4.0625 C 6.921875 -4.671875 6.625 -4.828125 6.453125 -4.828125 C 6.171875 -4.828125 5.90625 -4.53125 5.90625 -4.296875 C 5.90625 -4.15625 5.96875 -4.09375 6.0625 -4 C 6.1875 -3.875 6.453125 -3.59375 6.453125 -3.078125 C 6.453125 -2.375 5.890625 -1.484375 5.5 -1.09375 C 4.546875 -0.125 3.84375 -0.125 3.453125 -0.125 Z M 5.25 -7.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.453125 -6.59375 C 2.453125 -6.984375 2.484375 -7.109375 3.34375 -7.109375 L 3.625 -7.109375 L 3.625 -7.453125 C 3.25 -7.421875 2.390625 -7.421875 1.96875 -7.421875 C 1.546875 -7.421875 0.6875 -7.421875 0.3125 -7.453125 L 0.3125 -7.109375 L 0.59375 -7.109375 C 1.453125 -7.109375 1.484375 -6.984375 1.484375 -6.59375 L 1.484375 -0.84375 C 1.484375 -0.453125 1.453125 -0.34375 0.59375 -0.34375 L 0.3125 -0.34375 L 0.3125 0 C 0.6875 -0.03125 1.546875 -0.03125 1.96875 -0.03125 C 2.390625 -0.03125 3.25 -0.03125 3.625 0 L 3.625 -0.34375 L 3.34375 -0.34375 C 2.484375 -0.34375 2.453125 -0.453125 2.453125 -0.84375 Z M 2.453125 -6.59375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.140625 -0.59375 L 4.140625 0.125 L 5.75 0 L 5.75 -0.34375 C 4.984375 -0.34375 4.890625 -0.421875 4.890625 -0.953125 L 4.890625 -7.5625 L 3.328125 -7.453125 L 3.328125 -7.109375 C 4.09375 -7.109375 4.171875 -7.03125 4.171875 -6.5 L 4.171875 -4.140625 C 3.859375 -4.53125 3.390625 -4.828125 2.796875 -4.828125 C 1.515625 -4.828125 0.375 -3.75 0.375 -2.34375 C 0.375 -0.953125 1.4375 0.125 2.6875 0.125 C 3.375 0.125 3.875 -0.25 4.140625 -0.59375 Z M 4.140625 -3.515625 L 4.140625 -1.28125 C 4.140625 -1.09375 4.140625 -1.0625 4.03125 -0.890625 C 3.703125 -0.359375 3.203125 -0.125 2.734375 -0.125 C 2.25 -0.125 1.859375 -0.40625 1.59375 -0.8125 C 1.3125 -1.265625 1.28125 -1.890625 1.28125 -2.328125 C 1.28125 -2.734375 1.296875 -3.390625 1.609375 -3.875 C 1.84375 -4.21875 2.25 -4.578125 2.84375 -4.578125 C 3.234375 -4.578125 3.6875 -4.421875 4.03125 -3.921875 C 4.140625 -3.734375 4.140625 -3.71875 4.140625 -3.515625 Z M 4.140625 -3.515625 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 6.395,
    y: 14.766
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 61.743,
    y: 14.766
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 7.023,
    y: 58.621
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 62.296,
    y: 58.621
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -18.891 21.929875 L 16.898063 21.929875 ",
    transform: "matrix(1,0,0,-1,39.016,33.758)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 57.90625 11.828125 L 54.71875 10.234375 L 55.914062 11.828125 L 54.71875 13.425781 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 34.016,
    y: 7.995
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-2",
    x: 37.955276,
    y: 7.995
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -27.676156 -13.984187 L -27.676156 11.988469 ",
    transform: "matrix(1,0,0,-1,39.016,33.758)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.339844 19.773438 L 9.746094 22.964844 L 11.339844 21.769531 L 12.9375 22.964844 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 0.371,
    y: 35.046
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -19.519906 -21.9295 L 17.45275 -21.9295 ",
    transform: "matrix(1,0,0,-1,39.016,33.758)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 58.460938 55.6875 L 55.273438 54.09375 L 56.46875 55.6875 L 55.273438 57.28125 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-5",
    x: 35.836,
    y: 67.097
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 27.675406 -13.984187 L 27.675406 11.988469 ",
    transform: "matrix(1,0,0,-1,39.016,33.758)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 66.691406 19.773438 L 65.097656 22.964844 L 66.691406 21.769531 L 68.285156 22.964844 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-6",
    x: 70.525,
    y: 36.485
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.68acb4a66ffbdf8a0d4ccb07a68e2b9b.svg";
export { ForwardRef as ReactComponent };